(function(){
  if(window.__fateQsInit)return;
  window.__fateQsInit=true;
  var backdrop=document.createElement('div');
  backdrop.className='fate-qs-sheet__backdrop';
  var sheet=document.createElement('div');
  sheet.className='fate-qs-sheet';
  sheet.inert=true;
  sheet.setAttribute('role','dialog');
  sheet.setAttribute('aria-modal','true');
  sheet.setAttribute('aria-label','Seleccionar talla');
  sheet.innerHTML='<div class="fate-qs-sheet__handle"></div><div class="fate-qs-sheet__promo" hidden><strong></strong><span></span></div><div class="fate-qs-sheet__title"></div><div class="fate-qs-sheet__sizes"></div>';
  document.body.append(backdrop,sheet);
  var title=sheet.querySelector('.fate-qs-sheet__title');
  var sizes=sheet.querySelector('.fate-qs-sheet__sizes');
  var promo=sheet.querySelector('.fate-qs-sheet__promo');

  function variantId(data,size){
    var pos=data.sp-1;
    var card=document.querySelector('product-card[data-product-id="'+data.id+'"]');
    var selected=card&&card.querySelector('input[type="radio"]:checked');
    if(selected){
      for(var i=0;i<data.variants.length;i++){
        var variant=data.variants[i];
        if(variant.av&&variant.o[pos]===size&&variant.o.some(function(value,index){return index!==pos&&value===selected.value;}))return variant.id;
      }
    }
    for(var j=0;j<data.variants.length;j++)if(data.variants[j].av&&data.variants[j].o[pos]===size)return data.variants[j].id;
    return null;
  }

  // The deferred size picker can be ready before the cart module's imports.
  // Wait for its explicit readiness signal; never retry a cart write.
  function cartAddReady(){
    if(typeof window.__fateCartAdd==='function')return Promise.resolve(window.__fateCartAdd);
    return new Promise(function(resolve,reject){
      function ready(){
        if(typeof window.__fateCartAdd!=='function')return;
        clearTimeout(timeout);document.removeEventListener('fate:cart-ready',ready);
        resolve(window.__fateCartAdd);
      }
      var timeout=setTimeout(function(){
        document.removeEventListener('fate:cart-ready',ready);
        var failure=new Error('El carrito no terminó de cargar. Recarga la página e inténtalo de nuevo.');
        failure.cartNotReady=true;reject(failure);
      },15000);
      document.addEventListener('fate:cart-ready',ready);
      ready();
    });
  }
  function addError(failure){
    if(failure&&(failure.cartNotReady||failure.cartStatus===422||failure.variantUnavailable))return failure.message;
    return 'No se pudo confirmar el cambio. Revisa tu carrito antes de intentarlo de nuevo.';
  }
  function add(data,size,onSuccess,onError){
    var id=variantId(data,size);
    var fail=function(failure){if(onError)onError(failure);};
    if(!id){var failure=new Error('Esta talla no está disponible. Elige otra.');failure.variantUnavailable=true;fail(failure);return;}
    if(id&&typeof data.onSelect==='function'){
      Promise.resolve().then(function(){return data.onSelect(id);}).then(function(){if(onSuccess)onSuccess();}).catch(fail);
      return;
    }
    cartAddReady().then(function(cartAdd){return cartAdd(id,{openDrawer:false});}).then(function(){if(onSuccess)onSuccess();}).catch(fail);
  }

  var pending=false, returnFocus=null;
  var closeButton=document.createElement('button');closeButton.type='button';closeButton.className='fate-qs-sheet__close';closeButton.setAttribute('aria-label','Cerrar selector de talla');closeButton.textContent='×';closeButton.hidden=true;sheet.appendChild(closeButton);
  var error=document.createElement('p');error.className='fate-qs-sheet__error';error.setAttribute('role','alert');error.hidden=true;sheet.appendChild(error);
  function close(){sheet.inert=true;sheet.classList.remove('fate-qs-sheet--open');backdrop.classList.remove('fate-qs-sheet__backdrop--visible');var activeDrawer=document.querySelector('.cart-drawer__dialog[open]');if(returnFocus&&returnFocus.isConnected&&(!activeDrawer||activeDrawer.contains(returnFocus)))returnFocus.focus({preventScroll:true});}
  closeButton.addEventListener('click',close);
  function open(data){
    if(pending)return;
    returnFocus=data.returnFocus||document.activeElement;
    sheet.inert=false;
    var drawer=data.fromDrawer&&document.querySelector('.cart-drawer__dialog[open]');
    (drawer||document.body).append(backdrop,sheet);
    sheet.toggleAttribute('data-drawer-sheet',Boolean(drawer));closeButton.hidden=true;error.hidden=true;
    title.textContent=data.title;
    promo.hidden=!data.promo||!data.promo.label;
    promo.querySelector('strong').textContent=data.promo&&data.promo.label||'';
    promo.querySelector('span').textContent=data.promo&&data.promo.text||'';
    sheet.setAttribute('aria-label','Seleccionar talla: '+data.title);
    sizes.replaceChildren();
    var pos=data.sp-1,seen=[];
    data.variants.forEach(function(variant){
      var size=variant.o[pos];
      if(seen.indexOf(size)>-1)return;
      seen.push(size);
      var available=data.variants.some(function(item){return item.o[pos]===size&&item.av;});
      var button=document.createElement('button');
      button.type='button';button.className='fate-qs-sheet__sz'+(available?'':' fate-qs-sheet__sz--out');button.textContent=size;button.disabled=!available;
      button.addEventListener('click',function(){
        if(button.disabled||pending)return;pending=true;button.disabled=true;error.hidden=true;
        button.classList.add('fate-qs-sheet__sz--adding');button.textContent='...';
        add(data,size,function(){pending=false;close();},function(failure){pending=false;button.disabled=false;button.classList.remove('fate-qs-sheet__sz--adding');button.textContent=size;error.textContent=addError(failure);error.hidden=false;});
      });
      sizes.appendChild(button);
    });
    backdrop.classList.add('fate-qs-sheet__backdrop--visible');
    requestAnimationFrame(function(){sheet.classList.add('fate-qs-sheet--open');var first=sheet.querySelector('.fate-qs-sheet__sz:not(:disabled)');if(first)first.focus({preventScroll:true});});
  }

  backdrop.addEventListener('click',close);
  document.addEventListener('keydown',function(event){
    if(!sheet.classList.contains('fate-qs-sheet--open'))return;
    if(event.key==='Escape'){event.preventDefault();event.stopImmediatePropagation();close();return;}
    if(event.key==='Tab'){
      var targets=Array.from(sheet.querySelectorAll('button:not(:disabled):not([hidden])'));
      var first=targets[0],last=targets[targets.length-1];
      if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
      else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
    }
  },true);
  document.addEventListener('click',function(event){
    var pill=event.target.closest('.fate-qs__sz');
    if(pill&&!pill.disabled){
      event.preventDefault();event.stopPropagation();
      var container=pill.closest('[data-fate-qs]');var json=container&&container.querySelector('[data-fate-qs-data]');if(!json)return;
      var data=JSON.parse(json.textContent),label=pill.textContent;pill.disabled=true;
      pill.classList.add('fate-qs__sz--adding');pill.textContent='...';
      add(data,pill.dataset.size,function(){pill.textContent='✓';setTimeout(function(){pill.disabled=false;pill.classList.remove('fate-qs__sz--adding');pill.textContent=label;},1200);},function(){pill.disabled=false;pill.classList.remove('fate-qs__sz--adding');pill.textContent=label;});
      return;
    }
    var plus=event.target.closest('.fate-qs__plus');
    if(!plus)return;
    event.preventDefault();event.stopPropagation();
    var host=plus.closest('[data-fate-qs]');var dataNode=host&&host.querySelector('[data-fate-qs-data]');if(dataNode)open(JSON.parse(dataNode.textContent));
  },true);
  window.__fateQsOpenSheet=open;
  window.__fateQsCloseSheet=close;
})();
